import { render } from "./WithAddon.vue?vue&type=template&id=62d1357c"
import script from "./WithAddon.vue?vue&type=script&lang=js"
export * from "./WithAddon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__